import { truncateRichContent } from '@wix/ricos/content';
import { useState } from 'react';
export function useTruncateRicosContent(content, maxShownParagraphs) {
    const [isTruncated, setIsTruncated] = useState(true);
    function toggleTruncate() {
        setIsTruncated((prevState)=>!prevState);
    }
    return {
        displayedContent: maxShownParagraphs && isTruncated ? truncateRichContent(content, {
            nodeCount: maxShownParagraphs
        }) : content,
        isTruncated: maxShownParagraphs ? isTruncated : false,
        isTruncateButtonShown: maxShownParagraphs ? content.nodes.length > maxShownParagraphs : false,
        toggleTruncate
    };
}

//# sourceMappingURL=use-truncate-ricos-content.js.map